module.exports = new __parcel__URL__("priest.44bc4143.png").toString();